// Auto-generated by tools/avatar/generate-face-svgs.mjs
 
import type { RecordOfMouthComponents } from './types'

import ConcernedSvg from './concerned.svg?raw'
import DefaultSvg from './default.svg?raw'
import DisbeliefSvg from './disbelief.svg?raw'
import EatingSvg from './eating.svg?raw'
import GrimaceSvg from './grimace.svg?raw'
import SadSvg from './sad.svg?raw'
import ScreamOpenSvg from './scream-open.svg?raw'
import SeriousSvg from './serious.svg?raw'
import SmileSvg from './smile.svg?raw'
import TongueSvg from './tongue.svg?raw'
import TwinkleSvg from './twinkle.svg?raw'
import VomitSvg from './vomit.svg?raw'

export const mouthComponents = {
  Concerned: ConcernedSvg,
  Default: DefaultSvg,
  Disbelief: DisbeliefSvg,
  Eating: EatingSvg,
  Grimace: GrimaceSvg,
  Sad: SadSvg,
  ScreamOpen: ScreamOpenSvg,
  Serious: SeriousSvg,
  Smile: SmileSvg,
  Tongue: TongueSvg,
  Twinkle: TwinkleSvg,
  Vomit: VomitSvg,
} satisfies RecordOfMouthComponents

export type MouthComponentName = keyof typeof mouthComponents
